import { render, staticRenderFns } from "./AssigningPolicies.vue?vue&type=template&id=0047bbb2&"
import script from "./AssigningPolicies.vue?vue&type=script&lang=js&"
export * from "./AssigningPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports